import React, { useState } from "react";
import Navigation from "../../components/Navigation";
import axios from "axios";
import Constants from "../Variables/Constants";
import rightArrow from "../../assets/images/icons/rightArrow.png";
import { NavLink, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    confirm: false,
  });

  const [pwdPayload, setPwdPayload] = useState({
    current_password: "",
    new_password: "",
    confirm_new_password: ""
  })

  const togglePassword = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const validatePhone = (phone, label) => {
    if (!phone) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error(`${label} is required`);
      return false;
    }



    return true;
  };


  const validateConfirmPhone = () => {
    if (pwdPayload.new_password !== pwdPayload.confirm_new_password) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Phone numbers do not match");
      return false;
    }
    return true;
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  if (
    validatePhone(pwdPayload.current_password, "Old phone") &&
    validatePhone(pwdPayload.new_password, "New phone") &&
    validatePhone(pwdPayload.confirm_new_password, "Confirm phone") &&
    validateConfirmPhone()
  ) {
    const url = Constants.postUrls.changePassword;

    try {
      const response = await axios.post(
        url,
        pwdPayload,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      if (response.data.status === "success") {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.success("Phone Updated Successfully!");
        navigate("/profile");
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(response.data.message);
      }

    } catch (error) {
      toast.clearWaitingQueue();
      toast.dismiss();

      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong");
      }

      console.error(error);
    }
  }
};

  return (
    <div>
      {/* <Navigation /> */}
      <nav className="my-5 font-poppins route-navigation">
        <ul className="d-flex gap-4 text-light-gray fs-20 fw-bold ">
          <NavLink to={"/"}>
            <li className="list-unstyled">HOME</li>
          </NavLink>
          <li className="list-unstyled">
            <img loading="lazy" src={rightArrow} alt="" />
          </li>
          <NavLink to={"/profile"}>
            <li className="list-unstyled">Profile</li>
          </NavLink>
          <li className="list-unstyled">
            <img loading="lazy" src={rightArrow} alt="" />
          </li>
          <NavLink to={"/settings"}>
            <li className="list-unstyled">Settings</li>
          </NavLink>
          <li className="list-unstyled">
            <img loading="lazy" src={rightArrow} alt="" />
          </li>
          <NavLink to={"/change-password"}>
            <li className="list-unstyled text-dark">Change Password</li>
          </NavLink>
        </ul>
      </nav>

      <div className="mx-auto addAddress p-4">
        <form onSubmit={handleSubmit}>
          <div className="mb-3 position-relative">
            <label className="fw-500 fs-14 mb-2">Old Phone</label>
            <div className="position-relative">

              <input
                type="tel"
                maxLength={10}
                className="form-control p-4 rounded-4"
                placeholder="Enter old phone number"
                required
                value={pwdPayload.current_password}
                onChange={(e) =>
                  setPwdPayload({ ...pwdPayload, current_password: e.target.value })
                }
              />
              <img loading="lazy"
                src={
                  showPassword.old
                    ? "/eyeClose.png"
                    : "https://img.icons8.com/metro/26/visible.png"
                }
                alt="toggle password"
                className=" position-absolute"
                style={{
                  right: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  width: "20px",
                }}
                onClick={() => togglePassword("old")}
              />
            </div>
          </div>

          <div className="mb-3 position-relative">
            <label className="fw-500 fs-14 mb-2">New Phone</label>
            <div className="position-relative">
              <input
                type="tel"
                maxLength={10}
                className="form-control p-4 rounded-4"
                placeholder="Enter new phone number"
                required
                value={pwdPayload.new_password}
                onChange={(e) =>
                  setPwdPayload({ ...pwdPayload, new_password: e.target.value })
                }
              />
              <img loading="lazy"
                src={
                  showPassword.new
                    ? "/eyeClose.png"
                    : "https://img.icons8.com/metro/26/visible.png"
                }
                alt="toggle password"
                className=" position-absolute"
                style={{
                  right: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  width: "20px",
                }}
                onClick={() => togglePassword("new")}
              />
            </div>
          </div>

          <div className="mb-5 position-relative">
            <label className="fw-500 fs-14 mb-2">Confirm New Phone</label>
            <div className="position-relative">
              <input
                type="tel"
                maxLength={10}
                className="form-control p-4 rounded-4"
                placeholder="Confirm phone number"
                required
                value={pwdPayload.confirm_new_password}
                onChange={(e) =>
                  setPwdPayload({
                    ...pwdPayload,
                    confirm_new_password: e.target.value,
                  })
                }
              />
              <img loading="lazy"
                src={
                  showPassword.confirm
                    ? "/eyeClose.png"
                    : "https://img.icons8.com/metro/26/visible.png"
                }
                alt="toggle password"
                className=" position-absolute"
                style={{
                  right: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  width: "20px",
                }}
                onClick={() => togglePassword("confirm")}
              />
            </div>
          </div>

          <div className="d-flex gap-4 justify-content-between mt-4">
            <button type="button" className="btn w-50 bg-light-gray"
              onClick={
                () => {
                  navigate("/profile");
                }
              }
            >
              Cancel
            </button>
            <button type="submit" className="btn w-50 btn-warning text-white">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
